import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

declare const $: any;

@Component({
  selector: 'app-officer-master',
  templateUrl: './officer-master.component.html',
  styleUrls: ['./officer-master.component.scss']
})
export class OfficerMasterComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  // dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  isEditMode: boolean = false;
  officerForm: any = {}
  

  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe : DatePipe
  ) { }


  isLoading=false;
  ngOnInit() {
    this.ViewOfficers();
    this.ViewZone("");
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Officer Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Officer Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Officer Master' 
        }
      ]
    };
    
  }

  positionList = [
    { id: 'HO', name: 'HO' },
    { id: 'CSI', name: 'CSI' },
    { id: 'ACSI', name: 'ACSI' },
    { id: 'Daroga', name: 'Daroga' },
    { id: 'ZO', name: 'ZO' }
  ];

  positionTypeList = [
    { id: 'Main', name: 'Main' },
    { id: 'Assistant', name: 'Assistant' }
  ];

  shiftList = [
    { id: 'General', name: 'General' },
    { id: 'Morning', name: 'Morning' },
    { id: 'Evening', name: 'Evening' },
    { id: 'Night', name: 'Night' }
  ];

  filterPositionList:any = this.positionList;
  filterTypeList:any = this.positionTypeList;
  filterShiftList:any = this.shiftList;
  filterZoneList:any=[];
  filterWardList:any=[];

  zoneRowdata:any;
  zone_details=[];
  zoneDataArr:any=[];
  async ViewZone(zone_id:any){
    try {
      const zone_data = {
        'zone_no':zone_id,
      };
      this.zone_details=[];
      console.log(zone_data);
      const data: any = await this.request.post('/master/view_zone_master',zone_data);
      console.log(data);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].zone_id,
              zone_name:dataObj[objKey1].zone_no+" ("+dataObj[objKey1].zone_name+")"
            };
            // console.log(arr);
            this.zone_details.push(arr);
          } 
        }				
      }
      this.zoneDataArr = this.zone_details;
      this.filterZoneList = this.zoneDataArr;
    } catch (error) {}
  }

  zoneId=0;
  async GetZoneName(zone_id){
    // alert(zone_id);
     if (!this.officerForm.zone_id ||
        this.officerForm.zone_id.length === 0) {
      return;
    }

    let arr = {
      id:"0",
      ward_name:"Select Ward"
    };
    this.ward_details.push(arr);
    
    for (let zoneId of this.officerForm.zone_id) {
      await this.ViewWardByZone(zoneId);
    }
    this.wardDataArr = [...this.wardDataArr];
    this.filterWardList = this.wardDataArr;
  }

  ward_details=[];
  wardDataArr:any=[];
  async ViewWardByZone_old(zone_id:any){
    try {
      const zone_data = {
        'zone_no':zone_id,
      };
      this.ward_details=[];
      const data: any = await this.request.post('/master/view_ward_master_by_zone',zone_data);
      // console.log(data);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].ward_id,
              ward_name:dataObj[objKey1].ward_no+" ("+dataObj[objKey1].ward_name+")"
            };
            // console.log(arr);
            this.ward_details.push(arr);
          } 
        }				
      }
      this.wardDataArr = this.ward_details;
    } catch (error) {}
  }

  async ViewWardByZone(zone_id: any) {
    try {

      const data: any =await this.request.post('/master/view_ward_master_by_zone',
        {
          zone_no: zone_id
        }
      );
      if (data.result) {
        for (let ward of data.result) {
          // alert(ward.ward_id);
          const exists = this.wardDataArr && this.wardDataArr.some((x: any) => x.id === ward.ward_id);
          // alert(ward.ward_id);
          if (!exists) {
            // alert(ward.ward_id);
             let arr = {
              id:ward.ward_id,
              ward_name:ward.ward_no+" ("+ward.ward_name+")"
            };
            this.ward_details.push(arr);
          }
        }
        this.wardDataArr = this.ward_details;
      }
      console.log(this.wardDataArr);
    } catch (error) {
      console.log(error);
    }
  }


  ClearForm(){
    this.isEditMode=false;
    this.officerForm={};
  }

  officerViewDetails:any;
  async EditOfficer(officer_id:any){
    try {
      this.ClearForm();
      this.isEditMode=true;
      const officers = {
        'officer_id': officer_id,
      };
      const data: any = await this.request.post('/master/view_officer',officers);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            this.officerViewDetails = dataObj[objKey1];
          } 
        }				
      }
      this.officerForm = this.officerViewDetails;

      this.officerForm.zone_id = this.officerForm.zone_id || [];
      this.officerForm.ward_id = this.officerForm.ward_id || [];

      this.wardDataArr = [];
      this.ward_details=[];
      for (let zoneId of this.officerForm.zone_id) {
        await this.ViewWardByZone(zoneId);
      }
      this.wardDataArr = [...this.wardDataArr];

      $("#officer_id").val(this.officerForm.officer_id);
    } catch (error) {}
  }

  filterObj: any = {
    position: null,
    position_type: null,
    shift: null,
    zone_ids: [],
    ward_ids: []
  };

  async onFilterZoneChange() {

    this.filterWardList = [];
    this.filterObj.ward_ids = [];

    if (!this.filterObj.zone_ids ||
        this.filterObj.zone_ids.length === 0) {

      this.applyFilter();
      return;
    }

    // Default option
    this.filterWardList.push({
      id: 0,
      ward_name: 'Select Ward'
    });

    for (let zoneId of this.filterObj.zone_ids) {
      await this.ViewWardByZone(zoneId);
    }

    this.filterWardList = [...this.wardDataArr];

    this.applyFilter();
  }

  officerRowdata:any;
  officerDetails=[];
  allOfficerData: any[] = [];
  async ViewOfficers(){
    try {
      this.isLoading=true;
      // alert("here");
      const officers = {
        'officer_id': 0,
      };
      // this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_officer',officers);
      this.officerDetails=[];
      // this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            this.officerDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.officerRowdata = this.officerDetails;
      this.allOfficerData = [...this.officerDetails];
      this.rerender(); 
      this.isLoading=false;
    } catch (error) {}
  }


  // applyFilter() {

  //   this.officerRowdata =
  //     this.allOfficerData.filter((x: any) => {

  //       const positionMatch =
  //         !this.filterObj.position ||
  //         x.position ===
  //           this.filterObj.position;

  //       const typeMatch =
  //         !this.filterObj.position_type ||
  //         x.position_type ===
  //           this.filterObj.position_type;

  //       const shiftMatch =
  //         !this.filterObj.shift ||
  //         x.shift ===
  //           this.filterObj.shift;

  //       const zoneMatch =
  //         !this.filterObj.zone_id ||
  //         (x.zone_id + '')
  //           .indexOf(
  //             this.filterObj.zone_id + ''
  //           ) > -1;

  //       const wardMatch =
  //         !this.filterObj.ward_id ||
  //         (x.ward_id + '')
  //           .indexOf(
  //             this.filterObj.ward_id + ''
  //           ) > -1;

  //       return (
  //         positionMatch &&
  //         typeMatch &&
  //         shiftMatch &&
  //         zoneMatch &&
  //         wardMatch
  //       );
  //     });
  //   this.rerender(); 
  // }

  applyFilter() {

    this.officerRowdata =
      this.allOfficerData.filter((x: any) => {

        const positionMatch =
          !this.filterObj.position ||
          x.position ===
          this.filterObj.position;

        const typeMatch =
          !this.filterObj.position_type ||
          x.position_type ===
          this.filterObj.position_type;

        const shiftMatch =
          !this.filterObj.shift ||
          x.shift ===
          this.filterObj.shift;

        // Zone Match
        const zoneMatch =
          !this.filterObj.zone_ids ||
          this.filterObj.zone_ids.length === 0 ||
          this.filterObj.zone_ids.some(
            (z: any) =>
              (x.zone_id + '')
                .split(',')
                .includes(z + '')
          );

        // Ward Match
        const wardMatch =
          !this.filterObj.ward_ids ||
          this.filterObj.ward_ids.length === 0 ||
          this.filterObj.ward_ids.some(
            (w: any) =>
              (x.ward_id + '')
                .split(',')
                .includes(w + '')
          );

        return (
          positionMatch &&
          typeMatch &&
          shiftMatch &&
          zoneMatch &&
          wardMatch
        );
      });

    this.rerender();
  }

  clearFilter() {

    this.filterObj = {
      position: null,
      position_type: null,
      shift: null,
      zone_id: [],
      ward_id: []
    };

    this.officerRowdata = [
      ...this.allOfficerData
    ];

    this.rerender(); 
  }

  onSubmit(): void {
  if (this.isEditMode) {
    this.UpdateOfficers();
  } else {
    this.SaveOfficers();
  }
}

  isViewMode = false;
  isUpdatedRecord:any;
  message:any;
  async SaveOfficers() {
    try {
      // console.log(this.officerForm);
      const save: any = await this.request.post('/master/add_officer',this.officerForm);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }

  }

  async UpdateOfficers() {
    try {
      // console.log(this.officerForm);
      const save: any = await this.request.post('/master/update_officer',this.officerForm);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }

  }

  async DeleteOfficer(officer_id:any){
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
    if (confirm.value) {
      const officers = {
        'officer_id': officer_id
      };
      const allow: any = await this.request.post('/master/delete_officer/',officers);
      if (allow) {
      Swal.fire(
      'Deleted!',
      'Officer Information has been deleted.',
      'success'
      );
      // Reload DataTable
      window.location.reload();
      } else {
      Swal.fire(
        'Error!'
      );
      }
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
